'use client'
import { motion } from 'framer-motion'

export function BrokerGatewaySection() {
  return (
    <section
      id="broker-gateway"
      className="relative overflow-hidden"
    >
      {/* Aerial video background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        poster="/images/broker-drone.png"
      >
        <source src="/videos/broker-aerial.mp4" type="video/mp4" />
      </video>
      {/* Dark overlay so glass card remains readable */}
      <div className="absolute inset-0 bg-[#0f172a]/80" />

      <div className="relative z-10 py-24">
        <div className="page-container">
          <motion.div
            className="glass-card backdrop-blur-sm rounded-2xl p-10 md:p-16 flex flex-col items-center text-center gap-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-120px' }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
              Broker Gateway
            </h2>

            <p className="text-white/90 text-lg leading-relaxed max-w-xl">
              Get a freight quote or connect via EDI. We respond to RFQs within 2 hours
              during business hours. MC# 1394560 — Fully Insured.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
              <a
                href="#quote"
                className="glass-button btn-quote px-10 py-4 text-base font-semibold rounded-xl min-w-[200px] text-center"
              >
                Request Quote
              </a>
              <a
                href="#edi"
                className="glass-button btn-edi px-10 py-4 text-base font-semibold rounded-xl min-w-[200px] text-center"
              >
                EDI / Load Board
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
